module.exports = __webpack_public_path__ + "static/media/uh_red.37c15b96.png";